import $ from 'jquery';

export default function DETAIL() {
  $(function() {
    setTimeout(() => {
      $('.svg-pc, .svg-sp').addClass('is-active');
    }, 500);
  });
}